import 'firebase/functions'

import { Button, CircularProgress, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { showError } from '../../actions/misc/misc.actions'
import { DataDialog } from '../../components/Dialogs'
import { api } from '../../services/api'

// Required for side-effects
const pages = [
	'StartCheckIn',
	'ScheduleDaycare',
	'ScheduleBoarding',
	'Memberships',
	// "StartCheckIn",
	// "MyMembership",
	'Gallery',
	'Pets',
	'Bank'
]
const audience_options = ['All']
const useStyles = makeStyles((theme) => ({
	container: {
		flexGrow: 1
	},
	root: {
		flexGrow: 1,
		padding: 24,
		paddingBottom: 100
	},
	root2: {
		width: 45,
		height: 26,
		padding: 0,
		margin: theme.spacing(1)
	},
	switchBase: {
		padding: 1,
		'&$checked': {
			transform: 'translateX(16px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#52d869',
				opacity: 1,
				border: 'none'
			}
		},
		'&$focusVisible $thumb': {
			color: '#52d869',
			border: '6px solid #fff'
		}
	},
	thumb: {
		width: 24,
		height: 24
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(['background-color', 'border'])
	},
	bottomBar: {
		position: 'fixed',
		zIndex: 1000,
		bottom: 0,
		width: '100%',
		height: 60,
		backgroundColor: '#FFFFFF',
		border: '1px solid #D0CFD2',
		borderLeftWidth: 0,
		borderTopRightRadius: 6,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 20,
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35',
			marginRight: 17
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		}
	}
}))

const Exports = () => {
	const classes = useStyles()
	const dispatch = useDispatch()

	let [loading, setLoading] = useState(false)
	let [isShown, setIsShown] = useState(false)
	let [ourExport, setExport] = useState(null)
	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const runExport = (args) => {
		switch (ourExport) {
			case 'vaccineExpiration':
				getVaccineExpirations(args)
				break
			case 'householdData':
				getHouseholdData(args)
				break
			case 'membershipStatuses':
				getMembershipStatuses(args)
				break
			case 'barCheckInTimes':
				getBarCheckinTimes(args)
				break
			case 'firstBarCheckIn':
				getFirstBarCheckIn(args)
				break
			case 'checkIn':
				getCheckIn(args)
				break
			case 'addOns':
				getAddOns(args)
				break
			case 'dailyPets':
				getDailyPetsData(args)
				break
			case 'boardingExport':
				getBoardingData(args)
				break
			case 'daycareExport':
				getDaycareData(args)
				break
			case 'dogWalkingExport':
				getDogWalkingData(args)
				break
			case 'barRoster':
				getRoster(args)
				break
			default:
				break
		}
	}

	const onMount = []

	const getRoster = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/roster`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getMembershipStatuses = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/membershipStatuses`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getHouseholdData = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/householdData`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getVaccineExpirations = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/vaccineExpirations`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getBarCheckinTimes = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/barCheckInTimes`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getFirstBarCheckIn = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/firstBarCheckIn`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getCheckIn = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/checkIn`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const tester = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/homebaseGrooming`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: ``
			})

			console.log('data....', data)

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getAddOns = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/addOns`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getDailyPetsData = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			console.log('data str...', dataStr)

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/dailyPets`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			if (data.noData) {
				alert('No data for date range')
				setLoading(false)
				setIsShown(false)
				setExport(null)
				return
			}

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getBoardingData = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/getBoardingData`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getDogWalkingData = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/getDogWalkingData`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	const getDaycareData = async (args) => {
		try {
			setLoading(true)
			let dataStr = JSON.stringify({ ...args })

			let { data } = await api({
				url: `${process.env.REACT_APP_FIREBASE_URL}/getDaycareData`,
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: `data=${dataStr}`
			})

			console.log('data....', data)
			window.open(data.link, '_blank')

			setLoading(false)
			setIsShown(false)
			setExport(null)
		} catch (e) {
			console.log('huge e...', e)
			setLoading(false)
			dispatch(showError('Error fetching data'))
		}
	}

	return (
		<div className={classes.container}>
			<div className={classes.root}>
				<Typography variant="h5" style={{ fontSize: 22, marginBottom: 24, color: '#3B0275' }}>
					Exports
				</Typography>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Boarding Revenue Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All revenue from boarding visits within the time range. Visits can have multiple rows
							if they have more than one charge (addons, extended pickup, etc).
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							// flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						{/*<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								tester()
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Tester Guy'}
						</Button>*/}
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('boardingExport')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Daycare Revenue Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All revenue from daycare visits within the time range. Visits can have multiple rows if
							they have more than one charge (addons, extended pickup, etc).
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							// flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('daycareExport')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Home Service Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All revenue from home service visits within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							// flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('dogWalkingExport')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Daily Pets
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All facility pets within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('dailyPets')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Enrichments
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All facility enrichments completed within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('addOns')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Pet Care Pick-up & Drop-off Times
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All facility pick-ups & drop-offs completed within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('checkIn')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							First Time Bar Visitors Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All first bar check-ins completed within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('firstBarCheckIn')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Bar Check-In Times Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							Bar check-in times completed within the time range.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('barCheckInTimes')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Vaccine Expiration Dates Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							Information for all dogs with vaccine record expiration dates within the selected time
							range
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('vaccineExpiration')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Household Data Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All data on every household created within the time range
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('householdData')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Membership Statuses Report
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							All membership/pass information for memberships/passes that were started and ended
							within the selected time range. To see memberships that have not yet reached their term
							end date, do not put an end date on the time range for the export.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('membershipStatuses')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
				<Paper
					style={{
						padding: 24,
						marginBottom: 24,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between'
					}}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'flex-start'
						}}>
						<Typography
							variant="h5"
							style={{
								fontSize: 16,
								marginBottom: 4,
								color: '#1a1a35',
								fontWeight: '800'
							}}>
							Private Bar Member Roster
						</Typography>
						<Typography
							variant="body1"
							style={{
								fontSize: 14,
								marginBottom: 4,
								color: '#777679',
								fontWeight: '600',
								width: '60%'
							}}>
							Roster of bar members for the selected facility.
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button
							style={{
								fontWeight: 800,
								letterSpacing: 1.25,
								fontSize: '14px',
								lineHeight: '22px',
								backgroundColor: '#6B4AD6',
								borderRadius: 19,
								height: 38,
								color: '#FFFFFF',
								textTransform: 'uppercase',
								width: 200,
								padding: '6px 16px'
							}}
							variant="solid"
							onClick={() => {
								setIsShown(true)
								setExport('barRoster')
							}}
							disabled={loading}>
							{loading ? <CircularProgress /> : 'Prepare Export'}
						</Button>
					</div>
				</Paper>
			</div>
			<DataDialog
				isShown={isShown}
				loading={loading}
				type={ourExport}
				noDates={ourExport === 'barRoster' ? true : false}
				setIsShown={() => setIsShown(!isShown)}
				runExport={runExport}
				facilities={facilities}
			/>
		</div>
	)
}

export default Exports
